import { TefComs4cs4p } from '@mfe/components/TefComs4cs4p';
import { App } from '@mfec/types/model';
import { html } from 'lit';

const dateFormatter = new Intl.DateTimeFormat('de-DE', { month: '2-digit', day: '2-digit', year: 'numeric' });

//
// renders a single app consent block
//
// {app name}
// {app consent status}
//
export const singleAppConsent = function render(this: TefComs4cs4p, app: App) : ReturnType<typeof html> {
  const dateFormatted = dateFormatter.format(new Date(app.updatedAt));

  return html`
    <div class="row align-items-center">
      <div class="col">
        <div class="typography-display--6 typography-copy--regular">${app.name}</div>
        <div class=" typography-copy--3">Aktualisiert: ${dateFormatted}</div>
      </div>
      <tef-multi-checkbox
        ?disabled=${app.disabled}
        data-testid="app-consent-id-${app.consentId}"
        type="checkbox"
        value="${app.granted}"
        @change=${() => { this.handleUpdateConsentForApp(app); }}
        class="u-sb--flat"
      >
      </tef-multi-checkbox>
    </div>`;
};
